import useLocalization from '../../../hooks/use-localization';
import Button from '../../shared/Button';
import DateLabel from './parts/DateLabel';
import Image from './parts/Image';
import Meta from './parts/Meta';
import PostLink from './parts/PostLink';

export default function PostShort({ data }) {

    const localization = useLocalization();

    const postPath = `/post/${data.id}`;

    return (
        <div className="post-root">
            <div className="post-container">
                <div className="post-primary">
                    <div className="post">
                        <div className="post-header">

                            <DateLabel value={data.creationDate} alignRight={true}></DateLabel>

                            <PostLink href={postPath} text={data.title} />

                            <Image src={data.topImage} alt={data.title} />

                            <Meta author={data.author} categories={data.categories}></Meta>

                        </div>
                        <div className="post-content">
                            {data.topContent}

                        </div>
                        <div className="post-footer">
                            <Button type="type" href={postPath}>
                                {localization.continueReading}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}